import React from 'react';
import { IconProps } from '../types';
const MinecraftNetherSprouts: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="5" width="1" height="1" fill="rgba(20, 180, 133, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(17, 155, 133, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(20, 180, 133, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(20, 180, 133, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(17, 155, 133, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(20, 180, 133, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(17, 155, 133, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(20, 180, 133, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(17, 155, 133, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(20, 180, 133, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(17, 155, 133, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(17, 155, 133, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(20, 180, 133, 255)" />
<rect x="1" y="8" width="1" height="1" fill="rgba(22, 126, 134, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(17, 155, 133, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(17, 155, 133, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(22, 126, 134, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(17, 155, 133, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(22, 126, 134, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(22, 126, 134, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(20, 180, 133, 255)" />
<rect x="14" y="8" width="1" height="1" fill="rgba(17, 155, 133, 255)" />
<rect x="1" y="9" width="1" height="1" fill="rgba(22, 126, 134, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(22, 126, 134, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(17, 155, 133, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(22, 126, 134, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(22, 126, 134, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(22, 126, 134, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(22, 126, 134, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(17, 155, 133, 255)" />
<rect x="14" y="9" width="1" height="1" fill="rgba(22, 126, 134, 255)" />
</svg>);
export default MinecraftNetherSprouts;